<div class="fluid grid">

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="cliComLabel"
                         [parentCompany]="0"
                         [disabled]="true"
                         [selectedID]="newDocument.DOCMANCLIID"
                         (selectedCompanyID)="cliCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="cliPerLabel" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!newDocument.DOCMANCLIID"
                        [selectedID]="newDocument.DOCMANPERID" (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="manDepLabel"
                            [disabled]="true"
                            [parentCompany]="newDocument.DOCMANCLIID"
                            [selectedID]="newDocument.DOCMANDEPID"
                            (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="lcoComLabel"
                         [disabled]="true"
                         [parentCompany]="newDocument.DOCMANCLIID"
                         [selectedID]="newDocument.DOCLCOCLIID"
                         (selectedCompanyID)="lcoCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="lcoPerLabel"
                        [parentCompany]="newDocument.DOCLCOCLIID"
                        [disabled]="true"
                        [selectedID]="newDocument.DOCLCOPERID"
                        (selectedPersonID)="lcoPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="lcoDepLabel"
                            [disabled]="true"
                            [parentCompany]="newDocument.DOCLCOCLIID"
                            [selectedID]="newDocument.DOCLCODEPID"
                            (selectedDepartmentID)="lcoStockSelected($event)"></app-departmentselector>
  </div>

</div>
